<template>
  <div id="marquee-board">
    <dv-border-box-6>
      <div class="table-name" style=" padding-top: 12px; font-size: 26px">
        <div class="merquee">
          <span class="merquee-txt" >
            <span :style="{color: verifyStatusColor}">{{verifyStatusText}}</span>
            <span :style="{color: routingStatusColor}">{{routingStatusText}}</span>
          </span>
        </div>
      </div>
    </dv-border-box-6>
  </div>
</template>

<script>
export default {
  name: 'Marquee',
  data () {
    return {
      lineId: undefined,
      verifyStatusColor: 'greenyellow',
      verifyStatusText: '操作员PDA状态正常',
      routingStatusColor: 'greenyellow',
      routingStatusText: 'IPQC PDA状态正常'
    }
  },
  beforeMount(){
    const href = window.location.href
    const str = href.substr(href.indexOf("?")+1,href.length)
    const params = str.split('&')
    const code = params[0].split('=')[1]
    if (code){
      this.lineId = code;
    }
  },
  mounted () {
    const { getBigScreen } = this;
    getBigScreen();
    setInterval(getBigScreen, 30000);
  },
  methods: {
    async getBigScreen() {
      const data = await this.$http.post('https://apismt.moxitech.cn/admin-api/bigScreen/getWorkOrderLockStatus',{
        lineId: this.lineId
      }).then(res=>{
        return res.data.data
      }).catch(e=>{
        console.log(e)
      });
      let verifyText = "";
      let verifyStatusColor = "";
      let routingText = "";
      let routingStatusColor = "";
      if (data.verityLock == 1){
        verifyStatusColor = 'lawngreen';
        verifyText = verifyText + "操作员PDA状态正常；";
      }else if (data.verityLock == 2){
        verifyStatusColor = 'yellow';
        verifyText = verifyText + "操作员PDA即将锁定，请尽快进行核检；";
      }else if (data.verityLock == 3){
        verifyStatusColor = 'red';
        verifyText = verifyText + "操作员PDA已锁定；";
      }
      if (data.routingLock == 1){
        routingStatusColor = 'lawngreen';
        routingText = routingText + "IPQC PDA状态正常";
      }else if (data.routingLock == 2){
        routingStatusColor = 'yellow';
        routingText = routingText + "IPQC PDA即将锁定，请尽快经行巡检";
      }else if (data.routingLock == 3){
        routingStatusColor = 'red';
        routingText = routingText + "IPQC PDA已锁定";
      }

      this.verifyStatusText = verifyText;
      this.routingStatusText = routingText;
      this.verifyStatusColor = verifyStatusColor;
      this.routingStatusColor = routingStatusColor;
    }
  }
}
</script>

<style lang="less">
#marquee-board {
  width: 65%;
  height: 80px;
  box-sizing: border-box;
  margin-left: 20px;
  /*height: 100%;*/
  overflow: hidden;
  position: absolute;
  left: 32%;
  top: 880px;
}

.border-box-content {
  padding: 20px;
  box-sizing: border-box;
}

.table-name {
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;

  img {
    width: 40px;
    height: 40px;
    margin-right: 5px;
  }
}

.dv-marquee-board {
  height: calc(~"100% - 60px");
}

#marquee-board-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
}

.merquee {
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  word-break: break-all;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
.merquee-txt {
  display: inline-block;
  padding-left: 100%;
  /* 从右至左开始滚动 */
  animation: marqueeTransform 16s linear infinite;
}

@keyframes marqueeTransform {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(-100%, 0);
  }
}
</style>
